// import { getConfig } from "./readconfig";

class Config {
  get API_URL() {
    // return "https://backoffice.rwadiwala.com/backoffice/PCEPts/RW2WS/RWAOSWS.asmx/GOOGOLight4Apps";
    var apiUrl = process.env.REACT_APP_API_URL;
    if (window.location.href.toLowerCase().includes("http://localhost:3000/"))
      apiUrl = `${process.env.REACT_APP_API_URL_UAT}/RW2WS/RWAOSWS.asmx/GOOGOLight4Apps`;
    else if (window.location.href.toLowerCase().includes(`${process.env.REACT_APP_BASEPATH}`.toLocaleLowerCase()))
      apiUrl = `${process.env.REACT_APP_API_URL}/RW2WS/RWAOSWS.asmx/GOOGOLight4Apps`;
    else if (window.location.href.toLowerCase().includes(`${process.env.REACT_APP_BASEPATH_UAT}`.toLocaleLowerCase()))
      apiUrl = `${process.env.REACT_APP_API_URL_UAT}/RW2WS/RWAOSWS.asmx/GOOGOLight4Apps`;
    else if (window.location.href.toLowerCase().includes(`${process.env.REACT_APP_BASEPATH_LH}`.toLocaleLowerCase()))
      apiUrl = `${process.env.REACT_APP_API_URL_LH}/RW2WS/RWAOSWS.asmx/GOOGOLight4Apps`;
    else apiUrl = "https://backoffice.rwadiwala.com/Test";

    return apiUrl;
    /*
    return (
      `${process.env.REACT_APP_API_URL}/RW2WS/RWAOSWS.asmx/GOOGOLight4Apps` ||
      "https://backoffice.rwadiwala.com/Test"
    );
    */
  }

  get isSameOrigin() {
    return window.location.href.toLowerCase().startsWith(this.API_URL.toLocaleLowerCase());
  }

  get BASEPATH() {
    var baseURL = `${process.env.REACT_APP_BASEPATH || ""}`;

    if (window.location.href.toLowerCase().includes("http://localhost:3000/"))
      baseURL = "";
    else if (window.location.href.toLowerCase().includes(`${process.env.REACT_APP_BASEPATH}`.toLocaleLowerCase()))
      baseURL = `${process.env.REACT_APP_BASEPATH || ""}`;
    else if (window.location.href.toLowerCase().includes(`${process.env.REACT_APP_BASEPATH_UAT}`.toLocaleLowerCase()))
      baseURL = `${process.env.REACT_APP_BASEPATH_UAT || ""}`;
    else if (window.location.href.toLowerCase().includes(`${process.env.REACT_APP_BASEPATH_LH}`.toLocaleLowerCase()))
      baseURL = `${process.env.REACT_APP_BASEPATH_LH || ""}`;
    else baseURL = "https://backoffice.rwadiwala.com/Test";

    return baseURL;

    /*
    var baseURL = `${process.env.REACT_APP_BASEPATH || ""}`;
    if (getConfig().APP_MODE === "L")
      baseURL = `${process.env.REACT_APP_BASEPATH || ""}`;
    else if (getConfig().APP_MODE === "U")
      baseURL = `${process.env.REACT_APP_BASEPATH_UAT || ""}`;
    else if (getConfig().APP_MODE === "LH")
      baseURL = `${process.env.REACT_APP_BASEPATH_LH || ""}`;
    else baseURL = "https://backoffice.rwadiwala.com/Test";

    return baseURL;
    */
    /*
    return `${process.env.REACT_APP_BASEPATH || ""}`;
    */
  }

  get isDevelopment() {
    return process.env.NODE_ENV === "development";
  }

  PERSIST_STORE = false;
}

const config = new Config();
(window as any)["config"] = config;
export default config;
